import { Component } from '@angular/core';

@Component({
  selector: 'app-public',
  standalone: false,
  templateUrl: './public.component.html',
  styleUrl: './public.component.css'
})
export class PublicComponent {

}
